/*
 *
 * NoAccessPage
 *
 */

import React from "react";
import { Col } from "react-bootstrap";
import Helmet from "react-helmet";
import RedirectNoPermission from "components/RedirectNoPermission";

export class NoAccessPage extends React.PureComponent {
  render() {
    return (
      <div>
        <Helmet
          title="Access Denied - Criteria"
          meta={[
            { name: "description", content: "Description of NoAccessPage" },
          ]}
        />
        <Col lg={12} md={12} sm={12} xs={12}>
          <RedirectNoPermission />
        </Col>
      </div>
    );
  }
}

export default NoAccessPage;
